import { DATA_TYPE_SERVICE_NAME, DataTypeServiceProvider } from './data-type.service'
import { DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatServiceProvider } from './data-type-format.service'
import { DATA_TYPE_GROUP_SERVICE_NAME, DataTypeGroupServiceProvider } from './data-type-group.service'

export const DATA_TYPE_SERVICES_MODULE_NAME = 'simax.services.data-type'

const locationServicesModule = angular.module(DATA_TYPE_SERVICES_MODULE_NAME, [])

locationServicesModule.provider(DATA_TYPE_SERVICE_NAME, DataTypeServiceProvider)
locationServicesModule.provider(DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatServiceProvider)
locationServicesModule.provider(DATA_TYPE_GROUP_SERVICE_NAME, DataTypeGroupServiceProvider)
